var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vqb-children"},_vm._l((_vm.query.children),function(child,index){return _c(_vm.getComponent(child.type),{key:index,tag:"component",staticClass:"my-2",attrs:{"depth":_vm.depth + 1,"query":child.query,"index":index,"vars":_vm.vars,"members":_vm.members}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }